import { Component, Input, AfterViewInit, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getSeverityLevelByValue } from 'src/utils/severity.utils';

@Component({
  selector: 'app-circular-meter',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './circular-meter.component.html',
  styleUrls: ['./circular-meter.component.scss'],
})
export class CircularMeterComponent implements AfterViewInit {
  @Input() value: number = 0;
  @Input() strokeColor: string = '';
  @Input() restColor: string = '';
  @Input() dataSeverity: string = '';
  @Input() invertColors: boolean = false;
  @Input() size: number = 136;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    this.updateVisualization();
  }

  ngOnChanges() {
    if (this.elementRef.nativeElement) {
      this.updateVisualization();
    }
  }

  getComputedStrokeColor(): string {
    if (this.strokeColor) {
      return this.strokeColor;
    }
    return this.getDefaultColors().color;
  }

  getComputedRestColor(): string {
    if (this.restColor) {
      return this.restColor;
    }
    return this.getDefaultColors().restColor;
  }

  getComputedSeverity(): string {
    if (this.dataSeverity) {
      return this.dataSeverity;
    }
    return this.getDefaultColors().class;
  }

  private getDefaultColors(): {
    class: string;
    color: string;
    restColor: string;
  } {
    return getSeverityLevelByValue(this.value, {
      invertColors: this.invertColors,
    });
  }

  private updateVisualization() {
    const r = 42;
    const c = 2 * Math.PI * r;
    const valueCircle = this.elementRef.nativeElement.querySelector('.value');
    if (valueCircle) {
      valueCircle.setAttribute(
        'stroke-dasharray',
        `${(this.value / 100) * c} ${c}`
      );
    }
    const centerNum =
      this.elementRef.nativeElement.querySelector('.center-num');
    if (centerNum) {
      centerNum.textContent = Math.round(this.value).toString();
    }
  }
}
